import Toast, { BaseToast } from 'react-native-toast-message';
import type { BaseToastProps } from 'react-native-toast-message/lib/src/types';

export function ToastProvider() {
  const success = (props: BaseToastProps) => (
    <BaseToast
      {...props}
      contentContainerStyle={{ paddingHorizontal: 15, paddingVertical: 10 }}
      onPress={props.onPress ?? Toast.hide}
      style={{
        borderLeftColor: '#008213',
        backgroundColor: '#E8F7EA',
        boxShadow: '0px 0px 6px #65A56E57',
        height: 'auto',
      }}
      text1NumberOfLines={1}
      text1Style={{
        color: '#008213',
        fontSize: 14,
        fontWeight: '700',
        marginBottom: 5,
      }}
      text2NumberOfLines={2}
      text2Style={{
        color: '#008213',
        fontSize: 14,
        fontWeight: '500',
      }}
    />
  );

  const toastConfig = { success };

  return <Toast config={toastConfig} />;
}
